module.exports = __webpack_public_path__ + "static/media/Tombeau-picture-3.28dc7638.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Themes/Tombeau/Tombeau-picture-3.jpg
// module id = 605
// module chunks = 0